const job_progress = {
  permissionSource: 'api::job-progress.job-progress',
  creationTitle: 'Create Job Progress',
  creationEndPoint: '/job-progress',
  detailTitle: 'Job Progress: :title',
  detailEndPoint:
    '/job-progress/:id?populate[0]=business_entity&populate[1]=client.whatsapp&populate[2]=equipments&populate[3]=gallery&populate[4]=inspectors&populate[5]=prepared_bys&populate[6]=project_types&populate[7]=staffs&populate[8]=project_detail.supporting_media&populate[9]=project_detail.doc_type&populate[10]=other_parties.client&populate[11]=other_parties.partner&populate[12]=other_parties.supplier&populate[13]=other_parties.supporting_media&populate[14]=other_parties.agent_fee_due_proof&populate[15]=contact_person',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Code',
          value: 'code',
          tag: 'input',
          type: 'text',
          placeholder: 'Project Code',
          required: true,
        },
        {
          label: 'Desc',
          value: 'desc',
          tag: 'input',
          type: 'text',
          placeholder: 'Desc',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Title',
          value: 'title',
          tag: 'input',
          type: 'text',
          placeholder: 'Title',
          required: true,
        },
        {
          label: 'Salary',
          value: 'salary',
          tag: 'input',
          type: 'number',
          placeholder: 'Salary',
          required: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Location',
          value: 'location',
          tag: 'input',
          type: 'text',
          placeholder: 'Location',
          required: true,
        },
        {
          label: 'EmploymentType',
          value: 'employment_type',
          tag: 'single-select',
          dataSourceUrl: '/clients',
          dataLabel: 'name',
          required: false,
        },
      ],
    },
    {
      label: 'Requirements',
      value: 'requirements',
      tag: 'richTextarea',
    },
    {
      label: 'Responsibilities',
      value: 'responsibilities',
      tag: 'richTextarea',
    },
  ],
  creationData: {
    business_entity: ':active_business_entity',
  },
}
export default job_progress
